import { motion } from "framer-motion";

const SB_MONO = "https://customer-assets.emergentagent.com/job_af8f5b12-cd02-481d-8aac-658ba1fd8e83/artifacts/uzu8frqy_mono.png";

export default function Loader() {
    return (
        <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            className="fixed inset-0 z-[100] flex items-center justify-center bg-sb"
            data-testid="page-loader"
        >
                <div className="flex flex-col items-center gap-6">
                    <motion.img
                        src={SB_MONO}
                        alt="SysBrains"
                        className="w-16 h-16 rounded-md sb-pulse"
                        initial={{ scale: 0.7, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    />
                    <div className="relative h-px w-32 overflow-hidden bg-sb-border" style={{ backgroundColor: "rgb(var(--sb-border) / 0.15)" }}>
                        <motion.div
                            initial={{ x: "-100%" }}
                            animate={{ x: "100%" }}
                            transition={{ duration: 1.4, ease: "easeInOut", repeat: Infinity }}
                            className="absolute inset-y-0 w-1/2 bg-sb-mint"
                        />
                    </div>
            </div>
        </motion.div>
    );
}
